<template>
  <div>
    <section class="hero d-flex align-items-center justify-content-center text-center">
      <div class="hero-content">
        <h1 class="fw-bold display-4">Welcome to <span class="brand">56yellowrosesLLC</span></h1>
        <p class="lead mb-4">High-quality products, trusted service.</p>
        <router-link to="/products" class="btn btn-light btn-lg shadow-sm hover-scale">Explore Our Products</router-link>
      </div>
    </section>

    <section class="container py-5">
      <div class="text-center mb-5">
        <h2 class="fw-bold mb-3">Who We Are</h2>
        <div class="divider mx-auto mb-4"></div>
        <p class="text-muted fs-5 mx-auto about-text">
          <strong>56yellowrosesLLC</strong> is a brand that curates premium and trustworthy 
          personal care products. We don’t produce — we select.  
          By working with reputable manufacturers and suppliers, we bring together products 
          that meet the highest standards of <strong>quality</strong> and <strong>safety</strong>.  
          Our passion lies in helping people find reliable essentials that enhance 
          their everyday well-being.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style scoped>
.hero {
  position: relative;
  background: url("@/assets/homeHero.jpg") center/cover no-repeat;
  min-height: 85vh;
  color: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  overflow: hidden;
}

.hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1;
  backdrop-filter: blur(2px);
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 700px;
  padding: 1rem;
  animation: fadeInUp 1.2s ease-out;
}

.hero h1 {
  font-size: clamp(2rem, 5vw, 3.5rem);
  line-height: 1.2;
  margin-bottom: 0.8rem;
}

.hero .brand {
  color: #C89D43;
}

.hero p {
  font-size: clamp(1.1rem, 2vw, 1.5rem);
  opacity: 0.9;
}

.btn {
  transition: all 0.3s ease;
  font-weight: 500;
  border-radius: 50px;
  padding: 0.75rem 2rem;
}

.hover-scale:hover {
  transform: scale(1.05);
}

.about-text {
  max-width: 800px;
  line-height: 1.7;
}

.divider {
  width: 60px;
  height: 4px;
  background: #ffd700;
  border-radius: 2px;
}

@keyframes fadeInUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .hero {
    min-height: 70vh;
  }
  .btn {
    padding: 0.6rem 1.5rem;
  }
}
</style>
